export default "/images/223cfe1e4d7e28ed34ae1af725040397.avif";